<template>
  <SoPageWithRightSidePanel v-model="current.isSidePanelCollapsed">
    <SoContainer fluid>
      <SoRow>
        <SoCol>
          <h4 class="text-h4">Account Health Checks</h4>
        </SoCol>
      </SoRow>
      <SoRow>
        <SoCol>
          <HealthChecksWidget></HealthChecksWidget>
        </SoCol>
      </SoRow>
      <SoRow>
        <SoCol>
          <h4 class="text-h4">Tariffs</h4>
        </SoCol>
      </SoRow>
      <SoRow>
        <SoCol>
          <MeterpointsOverviewWidget />
        </SoCol>
      </SoRow>
    </SoContainer>
    <template #sidePanel>
      <CustomerAccountInfoPanel></CustomerAccountInfoPanel>
    </template>
    <template #sidePanelRail>
      <CustomerAccountInfoRail></CustomerAccountInfoRail>
    </template>
  </SoPageWithRightSidePanel>
</template>

<script lang="ts">
  import { defineComponent } from "vue"
  import SoContainer from "@/components/SoContainer.vue"
  import SoPageWithRightSidePanel from "@/components/templates/SoPageWithRightSidePanel.vue"
  import CustomerAccountInfoPanel from "./CustomerAccountInfoPanel.vue"
  import CustomerAccountInfoRail from "./CustomerAccountInfoRail.vue"
  import SoRow from "@/components/SoRow.vue"
  import SoCol from "@/components/SoCol.vue"
  import HealthChecksWidget from "./widgets/HealthChecksWidget.vue"
  import MeterpointsOverviewWidget from "./widgets/MeterpointsOverviewWidget.vue"
  import { useCurrentAccountStore } from "@/stores/currentAccount"

  export default defineComponent({
    components: {
      SoContainer,
      SoPageWithRightSidePanel,
      CustomerAccountInfoPanel,
      CustomerAccountInfoRail,
      SoRow,
      SoCol,
      HealthChecksWidget,
      MeterpointsOverviewWidget,
    },
    data() {
      return {
        current: useCurrentAccountStore(),
      }
    },
  })
</script>
